module.exports = __webpack_public_path__ + "img/gonetwork2_icon7.ef97f350.png";